
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service",
      function () {
        return require("private-next-pages/customer-service/index.route.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service"])
      });
    }
  